import { NEXT_PLAN_LEVEL_API, SUCCESS_RESPONSES } from 'constants/AppConstants';

export default async () => {
  try {
    const response = await fetch(NEXT_PLAN_LEVEL_API);
    const json = await response.json();
    if (response.status !== SUCCESS_RESPONSES.SUCCESS_OK) return { ok: false, json };
    return { ok: true, json };
  } catch (err) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
